import 'react-app-polyfill/stable'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './utils/reportWebVitals'
import { ThemeProvider } from './contexts/ThemeContext'
import App from './App'
import { Amplify } from 'aws-amplify'
import { appSyncConfig } from './config'
import { GlobalStyles } from '@mui/material'
import { initDatadog } from './datadog'
import DSEG7ModernLight from './fonts/DSEG7-Modern/DSEG7Modern-Light.woff2'
import DSEG7ModernRegular from './fonts/DSEG7-Modern/DSEG7Modern-Regular.woff2'
import DSEG7ModernBold from './fonts/DSEG7-Modern/DSEG7Modern-Bold.woff2'
import DSEG7ModernLightItalic from './fonts/DSEG7-Modern/DSEG7Modern-LightItalic.woff2'
import DSEG7ModernItalic from './fonts/DSEG7-Modern/DSEG7Modern-Italic.woff2'
import DSEG7ModernBoldItalic from './fonts/DSEG7-Modern/DSEG7Modern-BoldItalic.woff2'

Amplify.configure(appSyncConfig)
initDatadog()

render(
  <BrowserRouter>
    <ThemeProvider>
      <GlobalStyles
        styles={{
          '@font-face': [
            {
              fontFamily: 'DSEG',
              fontWeight: 300,
              fontStyle: 'normal',
              src: `url(${DSEG7ModernLight}) format('woff2')`
            },
            {
              fontFamily: 'DSEG',
              fontWeight: 400,
              fontStyle: 'normal',
              src: `url(${DSEG7ModernRegular}) format('woff2')`
            },
            {
              fontFamily: 'DSEG',
              fontWeight: 700,
              fontStyle: 'normal',
              src: `url(${DSEG7ModernBold}) format('woff2')`
            },
            {
              fontFamily: 'DSEG',
              fontWeight: 300,
              fontStyle: 'italic',
              src: `url(${DSEG7ModernLightItalic}) format('woff2')`
            },
            {
              fontFamily: 'DSEG',
              fontWeight: 400,
              fontStyle: 'italic',
              src: `url(${DSEG7ModernItalic}) format('woff2')`
            },
            {
              fontFamily: 'DSEG',
              fontWeight: 700,
              fontStyle: 'italic',
              src: `url(${DSEG7ModernBoldItalic}) format('woff2')`
            }
          ],
          "input[type='number']": {
            MozAppearance: 'textfield'
          },
          'input::-webkit-outer-spin-button': {
            WebkitAppearance: 'none'
          },
          'input::-webkit-inner-spin-button': {
            WebkitAppearance: 'none'
          }
        }}
      />
      <App />
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
